import { Divider } from "@certn/cascadia-react";
import { ArrayLayoutProps } from "@jsonforms/core";
import { Text } from "../../../components/Text";

export function CustomAddSection(props: ArrayLayoutProps) {
  const {
    uischema: { options },
  } = props;
  const customAddSection = options?.customAddSection;

  if (customAddSection?.title || customAddSection?.subTitle) {
    return (
      <>
        <Divider />
        {customAddSection.title && (
          <Text style="form/section-heading">{customAddSection.title}</Text>
        )}
        {customAddSection.subTitle && (
          <Text style="form/body-secondary">{customAddSection.subTitle}</Text>
        )}
      </>
    );
  }

  return <></>;
}
